import { useEffect, useState } from "react";

const CATALOG_URL = "https://tigik.saubereko.eu/api/hof/skills-catalog";
let cache = null;

export function useSkillCatalog(lang) {
  const [catalog, setCatalog] = useState(cache);
  useEffect(() => {
    if (cache) return;
    fetch(CATALOG_URL).then((r) => r.json()).then((d) => { cache = d; setCatalog(d); }).catch(() => {});
  }, []);
  const groups = (catalog?.groups || []).map((g) => ({
    id: g.id,
    label: (g.labels && (g.labels[lang] || g.labels.sk)) || g.label || g.id,
    skills: (g.skills || []).map((s) => ({ id: s.id, label: (s.labels && (s.labels[lang] || s.labels.sk)) || s.id })),
  }));
  const labels = {};
  groups.forEach((g) => g.skills.forEach((s) => { labels[s.id] = s.label; }));
  return { groups, labels };
}

export const SkillChips = ({ ids, labels }) => (
  <div className="flex flex-wrap gap-1.5">
    {ids.map((id) => (
      <span key={id} className="text-[11px] px-2 py-0.5 border border-[#D4AF37]/30 text-[#F2E3C6]/85 bg-[#D4AF37]/5">{labels[id] || id}</span>
    ))}
  </div>
);
